import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TableConfig } from '@app/shared/util/table-config.utils';
import { ValueStreamConfiguration } from '@app/shared/models/value-stream-configuration.model';
import { Log } from "ng2-logger";

@Component({
    selector: 'app-value-streams-table',
    templateUrl: './value-streams-table.component.html',
    styleUrls: ['./value-streams-table.component.scss']
})
export class ValueStreamTableComponent {
    _logger = Log.create(ValueStreamTableComponent.name);

    @Input() valueStreams: ValueStreamConfiguration[] = [];
    @Input() tableConfig: TableConfig;
    @Input() isLoading = false;
    @Input() headerBackgroundColor: string;

    @Output() pageChange = new EventEmitter<any>();
    @Output() filterChange = new EventEmitter<any>();
    @Output() sortChange = new EventEmitter<any>();
    @Output() rowClick = new EventEmitter<any>();
    @Output() duplicateRow = new EventEmitter<any>();

    onPageChange(cfg: TableConfig) {
        this._logger.info('onPageChange::', cfg);
        this.pageChange.emit(cfg);
    }

    onSortChange(cfg: TableConfig) {
        this._logger.info('onSortChange::', cfg);
        this.sortChange.emit(cfg);
    }

    onFilterChange(cfg: TableConfig) {
        this._logger.info('onFilterChange::', cfg);
        this.filterChange.emit(cfg);
    }

    onRowClick(item) {
        this._logger.info('onRowClick::', item);
        this.rowClick.emit(item);
    }

    onDuplicate(item) {
        this._logger.info('onDuplicate::', item);
        this.duplicateRow.emit(item);
    }
}
